const runtime = (name) => require(`./assets/runtime/${name}`);
const logoContext = require.context("./assets", true, /\.png$/);
const logoAsset = (category, slug) => logoContext(`./${category}/${slug}.png`);

const CATALOG = {
  holidays: [
    ["01-new-year", "元旦"], ["02-spring-festival", "春节"], ["03-lantern-festival", "元宵节"],
    ["04-qingming-festival", "清明节"], ["05-labor-day", "劳动节"], ["06-dragon-boat", "端午节"],
    ["07-cpc-founding", "建党节"], ["08-army-day", "建军节"], ["09-teachers-day", "教师节"],
    ["10-mid-autumn", "中秋节"], ["11-national-day", "国庆节"],
  ],
  "solar-terms": [
    ["01-lichun", "立春"], ["02-yushui", "雨水"], ["03-jingzhe", "惊蛰"], ["04-chunfen", "春分"],
    ["05-qingming", "清明"], ["06-guyu", "谷雨"], ["07-lixia", "立夏"], ["08-xiaoman", "小满"],
    ["09-mangzhong", "芒种"], ["10-xiazhi", "夏至"], ["11-xiaoshu", "小暑"], ["12-dashu", "大暑"],
    ["13-liqiu", "立秋"], ["14-chushu", "处暑"], ["15-bailu", "白露"], ["16-qiufen", "秋分"],
    ["17-hanlu", "寒露"], ["18-shuangjiang", "霜降"], ["19-lidong", "立冬"], ["20-xiaoxue", "小雪"],
    ["21-daxue", "大雪"], ["22-dongzhi", "冬至"], ["23-xiaohan", "小寒"], ["24-dahan", "大寒"],
  ],
  scientists: [
    ["01-qian-xuesen", "钱学森"], ["02-yuan-longping", "袁隆平"], ["03-tu-youyou", "屠呦呦"],
    ["04-deng-jiaxian", "邓稼先"], ["05-hua-luogeng", "华罗庚"], ["06-chen-jingrun", "陈景润"],
    ["07-zhu-kezhen", "竺可桢"], ["08-li-siguang", "李四光"], ["09-mao-yisheng", "茅以升"],
    ["10-chien-shiung-wu", "吴健雄"],
  ],
};

const item = (category, slug, name, extra = {}) => ({
  key: slug, category, name, image: logoAsset(category, slug), navImage: logoAsset(category, slug), ...extra,
});

export const INDEX_LOGO_CATALOG = Object.fromEntries(
  Object.entries(CATALOG).map(([category, entries]) => [category, entries.map(([slug, name]) => item(category, slug, name))]),
);
const bySlug = Object.fromEntries(Object.values(INDEX_LOGO_CATALOG).flat().map((entry) => [entry.key, entry]));
const OVERRIDE_ALIASES = { "mid-autumn": "10-mid-autumn", "national-day": "11-national-day" };

const EVENT_2026 = [
  // 大节日默认提前两天；中秋和国庆使用用户指定的精确连续时间。
  ["01-new-year", "2025-12-30T00:00:00", "2026-01-04T00:00:00", 80],
  ["02-spring-festival", "2026-02-13T00:00:00", "2026-02-24T00:00:00", 80],
  ["03-lantern-festival", "2026-03-03T00:00:00", "2026-03-04T00:00:00", 50],
  ["04-qingming-festival", "2026-04-02T00:00:00", "2026-04-07T00:00:00", 80],
  ["05-labor-day", "2026-04-29T00:00:00", "2026-05-06T00:00:00", 80],
  ["06-dragon-boat", "2026-06-17T00:00:00", "2026-06-22T00:00:00", 80],
  ["07-cpc-founding", "2026-07-01T00:00:00", "2026-07-02T00:00:00", 50],
  ["08-army-day", "2026-08-01T00:00:00", "2026-08-02T00:00:00", 50],
  ["09-teachers-day", "2026-09-10T00:00:00", "2026-09-11T00:00:00", 50],
  ["10-mid-autumn", "2026-09-24T00:00:00", "2026-09-27T05:00:00", 100],
  ["11-national-day", "2026-09-27T05:00:00", "2026-10-09T00:00:00", 100],

  // 二十四节气在北京时间当天 00:00 至次日 00:00 展示。
  ["23-xiaohan", "2026-01-05T00:00:00", "2026-01-06T00:00:00", 40],
  ["24-dahan", "2026-01-20T00:00:00", "2026-01-21T00:00:00", 40],
  ["01-lichun", "2026-02-04T00:00:00", "2026-02-05T00:00:00", 40],
  ["02-yushui", "2026-02-18T00:00:00", "2026-02-19T00:00:00", 40],
  ["03-jingzhe", "2026-03-05T00:00:00", "2026-03-06T00:00:00", 40],
  ["04-chunfen", "2026-03-20T00:00:00", "2026-03-21T00:00:00", 40],
  ["05-qingming", "2026-04-05T00:00:00", "2026-04-06T00:00:00", 40],
  ["06-guyu", "2026-04-20T00:00:00", "2026-04-21T00:00:00", 40],
  ["07-lixia", "2026-05-05T00:00:00", "2026-05-06T00:00:00", 40],
  ["08-xiaoman", "2026-05-21T00:00:00", "2026-05-22T00:00:00", 40],
  ["09-mangzhong", "2026-06-05T00:00:00", "2026-06-06T00:00:00", 40],
  ["10-xiazhi", "2026-06-21T00:00:00", "2026-06-22T00:00:00", 40],
  ["11-xiaoshu", "2026-07-07T00:00:00", "2026-07-08T00:00:00", 40],
  ["12-dashu", "2026-07-23T00:00:00", "2026-07-24T00:00:00", 40],
  ["13-liqiu", "2026-08-07T00:00:00", "2026-08-08T00:00:00", 40],
  ["14-chushu", "2026-08-23T00:00:00", "2026-08-24T00:00:00", 40],
  ["15-bailu", "2026-09-07T00:00:00", "2026-09-08T00:00:00", 40],
  ["16-qiufen", "2026-09-23T00:00:00", "2026-09-24T00:00:00", 40],
  ["17-hanlu", "2026-10-08T00:00:00", "2026-10-09T00:00:00", 40],
  ["18-shuangjiang", "2026-10-23T00:00:00", "2026-10-24T00:00:00", 40],
  ["19-lidong", "2026-11-07T00:00:00", "2026-11-08T00:00:00", 40],
  ["20-xiaoxue", "2026-11-22T00:00:00", "2026-11-23T00:00:00", 40],
  ["21-daxue", "2026-12-07T00:00:00", "2026-12-08T00:00:00", 40],
  ["22-dongzhi", "2026-12-22T00:00:00", "2026-12-23T00:00:00", 40],
];

const SPECIAL = {
  "10-mid-autumn": { themeKey: "mid-autumn", image: runtime("10-mid-autumn-animated.gif"), navImage: runtime("nav-mid-autumn.png") },
  "11-national-day": { themeKey: "national-day", image: runtime("11-national-day-animated.gif"), navImage: runtime("nav-national-day-77.png"), anniversary: 77 },
};
const EVENTS = EVENT_2026.map(([key, start, end, priority]) => ({ ...bySlug[key], start, end, priority }));

export function chinaDateTimeKey(date = new Date()) {
  const parts = new Intl.DateTimeFormat("zh-CN", {
    timeZone: "Asia/Shanghai", year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23",
  }).formatToParts(date);
  const value = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return `${value.year}-${value.month}-${value.day}T${value.hour}:${value.minute}:${value.second}`;
}

const hydrate = (event) => ({ ...event, ...(SPECIAL[event.key] || {}) });

export function resolveHomeDoodles(date = new Date(), override = "") {
  if (override === "default" || override === "off") return [];
  const overrideKey = OVERRIDE_ALIASES[override] || override;
  if (bySlug[overrideKey]) return [hydrate(bySlug[overrideKey])];
  const now = chinaDateTimeKey(date);
  return EVENTS.filter((event) => now >= event.start && now < event.end)
    .sort((a, b) => b.priority - a.priority || a.start.localeCompare(b.start)).map(hydrate);
}

export function resolveHomeDoodle(date = new Date(), override = "") {
  const active = resolveHomeDoodles(date, override);
  if (!active.length) return null;
  // 重叠日不丢弃任何套装：每10秒轮换一次，全天持续展示全部有效事件。
  return active[Math.floor(date.getTime() / 10000) % active.length];
}

export const HOME_DOODLE_SCHEDULE = EVENTS;
